import { api } from '@cma/app'
import {
  PlatformContentQuery,
  PlatformContentQueryVariables
} from '@cma/generated/graphql'
import { useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export const PlatformClientContentFragment = gql`
  fragment ContentShareParts on ContentShare {
    id
    shareable {
      __typename
      ... on Brokerage {
        id
        name
        usersCount
      }
      ... on Office {
        id
        name
        usersCount
      }
      ... on PlatformClient {
        id
        platformAccountName
        usersCount
      }
      ... on Team {
        id
        name
        usersCount
      }
    }
    shareableContentId
    shareableContentType
    shareableId
    shareableType
    createdAt
  }

  fragment PlatformClientContentParts on PlatformClientContent {
    __typename
    id
    folderId
    displayName
    platformClientContentContentType
    platformClientContentUrl
    thumbnail
    contentShares {
      ...ContentShareParts
    }
    ownerId
    ownerType
    uploaderId
    uploader {
      name
      email
      avatar
    }
    createdAt
    updatedAt
  }
`

export function usePlatformContent(variables: PlatformContentQueryVariables) {
  return useQuery<PlatformContentQuery, Error>(
    ['platformContent', variables],
    () => {
      const query = gql`
        fragment PlatformClientFolderParts on Folder {
          __typename
          id
          ownerId
          ownerType
          displayName: name
          contentShares {
            ...ContentShareParts
          }
          customPages {
            ...PlatformClientContentParts
          }
          createdAt
          updatedAt
        }

        query PlatformContent($id: ID!) {
          platformContent: platformClient(id: $id) {
            id
            customContents {
              ...PlatformClientContentParts
            }
            folders {
              ...PlatformClientFolderParts
            }
          }
        }

        ${PlatformClientContentFragment}
      `
      return api<PlatformContentQuery, PlatformContentQueryVariables>({
        query,
        variables
      })
    },
    {
      enabled: !!variables.id
    }
  )
}
